<template>
  <section class="home-container d-flex flex-column h-100" :style="{ backgroundImage: `url(${banner1})` }">
    <HomeNav />
    <area class="mt-auto flex-shrink-0" v-if="showBanner" />
    <div class="container-fluid pb-5">
      <div class="row">
        <div class="col-md-12 col-lg-6 col-xl-6">
          <h1 class="mt-5 text-white punchline-heading">
            {{ getbannerDataName }}
          </h1>
          <p class="text-white banner-desc">
            {{ getbannerDataDesc }}
          </p>
          <p class="top-banner-btn-wrapper">
            <a @click="playvideo(bannerData)" v-if="!shouldShowResumeButton(bannerData)"
              class="btn btn-lg btn-outline-light">
              Watch Now
            </a>
            <a @click="getresumeHref(bannerData)" class="btn btn-lg btn-outline-light ml-2"
              v-if="shouldShowResumeButton(bannerData)">Resume</a>
            <a @click="toggleFavorited(bannerData)" class="btn btn-lg btn-light ml-2"><img class="icon1"
                src="../assets/img/minus-green.svg" v-if="my_favourite(bannerData)" />
              <img class="icon1" src="../assets/img/plus-green.svg" v-else />
              {{ FavTitle }}</a>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.btn-outline-light {
  color: #f1f2f2 !important;
}

.btn-outline-light:hover,
.btn-outline-light:focus {
  color: #f1f2f2 !important;
}

.btn-lg {
  font-size: 14px;
  padding: 12px 30px !important;
  align-items: center;
}

.icon1 {
  align-items: center;
  padding-bottom: 2%;
}

.home-container {
  min-height: 100vh !important;
}

.container-fluid {
  position: relative;
  z-index: 1;
}

.banner-desc {
  font-size: 1.3vw;
}


@media only screen and (max-width: 768px) {
  .banner-desc {
    font-size: 20px !important;
    padding: 8px 0px;
  }

  .btn-lg {
    font-size: 16px;
    padding: 12px 30px !important;
  }
}
</style>
<script>
import HomeNav from "@/components/HomeNav.vue";
export default {
  components: {
    HomeNav,
  },
  name: "Header",
  props: ["title", "apiOptions"],
  methods: {
    goToDetails(current) {
      var dynamicRoute = "";
      if (current.type == "vod") {
        dynamicRoute = "/details/" + current.id + "/" + this.apiOptions;
      } else if (current.type == "Season") {
        dynamicRoute = "/playlistdetails/" + this.apiOptions;
      }
      this.$router.push("" + dynamicRoute);
    },

    playvideo(current) {
      this.checkSubs(current);
    },

    my_favourite(show) {
      if (show != null) {
        for (var i = 0; i < this.$store.state.user.mylist.length; i++) {
          var item = this.$store.state.user.mylist[i];
          if (item.id == show.id) return true;
        }
        return false;
      }
    },
    toggleFavorited(show) {
      this.$store.commit("refreshMyList", false);
      if (this.my_favourite(show)) {
        this.$store
          .dispatch("updatemyList", {
            id: show.id,
            value: false,
            type: show.type,
          })
          .then(() => {
            // this.$store.commit("refreshMyList" ,true)
          });
      } else {
        this.$store
          .dispatch("updatemyList", {
            id: show.id,
            value: true,
            type: show.type,
          })
          .then(() => {
            //this.$store.commit("refreshMyList" ,true)
          });
      }
    },
    showSearchPage() {
      this.$router.push("/search");
    },
    goToaccount() {
      this.$router.push("/account");
    },
    logout() {
      this.$store.dispatch("logout").then((res) => {
        if (res == "true") {
          this.$router.push("/");
        }
      });
    },
    shouldShowResumeButton(video) {
      if (video) {
        return this.$store.getters.isvideoResume(video.id);
      }

    },
    getresumeHref(video) {
      this.checkSubs(video);
    },
    checkSubs(current) {
      this.$store
        .dispatch("getVideoPlaybackURLV2", {
          videoId: current.id,
          deviceId: this.duidVal,
        })
        .then((res) => {
          if (current.type == "Series") {
            var currentCat = current.id;
            this.$store.dispatch("getCatalougeById", currentCat).then((res) => {
              var currentSeason = res._embedded.items[0].id;
              this.$store
                .dispatch("getCatalougeById", currentSeason)
                .then((res) => {
                  var currentSeasonVideoId = res._embedded.items[0].id;
                  var dynamicRoute = "/viewvideo/" + currentSeasonVideoId;
                  this.$router.push("" + dynamicRoute);
                });
            });
          } else {
            if (this.resume == true) {
              var dynamicRoute = "/viewvideo/" + current.id + "?resume=true";
              this.$router.push("" + dynamicRoute);
            } else var dynamicRoute = "/viewvideo/" + current.id;
            this.$router.push("" + dynamicRoute);
          }
        })
        .catch((err) => {
          if (err.response.data.error.status == "422") {
            // show upgrade screen popup
          }
          if (err.response.data.error.status == "403") {
            this.$store.commit("showPopup", true);
            this.$store.commit("showdefaultFooter", false)
            window.scrollTo(0, 0);
          }
          if (err.response.data.error.status == "404 ") {
            this.$store.commit("showPopup", true);
            //this.$store.commit("setNotification", "Please try again later ");
            window.scrollTo(0, 0);
          }
          this.$store.commit("setLoader", false);
        });
    },
  },
  created() {
    this.$store.commit("showPopup", false);
    this.$store.dispatch("getCatalougeById", this.apiOptions).then((res) => {
      if (res._embedded.items && res._embedded.items.length > 0) {
        this.bannerData = res._embedded.items[0];
        if (this.bannerData.metaData.bannerImage) {
          this.banner1 = this.bannerData.metaData.bannerImage;
        }
        this.showBanner = true;
      }

    });
  },
  data() {
    return {
      bannerData: null,
      showBanner: false,
      banner1: "/img/homepage-bg.a82c63d7.png",
      bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
      duidVal: null,
      resume: null
    };
  },
  computed: {
    FavTitle() {
      if (this.my_favourite(this.bannerData)) {
        return "Remove from List";
      } else {
        return "Add to List";
      }
    },
    getbannerDataName() {
      if (this.bannerData) {
        if (this.bannerData.name) {
          return this.bannerData.name;
        }
        return "";
      } else return;
    },

    getbannerDataDesc() {
      if (this.bannerData) {
        if (this.bannerData.description) {
          return this.bannerData.description;
        }
        return "";
      } else return;
    },

    message: {
      get() {
        return this.$store.state.search.message;
      },
      set(value) {
        this.$store.commit("updateSearchMessage", value);
      },
    },
  },
};
</script>
